
// use Shopify Section Rendering API to re-render a section

(() => {
  let variant = new URLSearchParams(window.location.search).get('variant');

  /**
   * @type {Record<string, Record<string, string>>}
   */
  let cache = {};

  /**
   * 
   * @param {string} sections 
   * @returns 
   */
  async function renderSections(variant) {

    // get all elements with data-rerender attribute
    let sections = Array.from(document.querySelectorAll('[data-rerender]'));

    // for every element get the section id from the closest parent with an id starting with 'shopify-section-'
    const sectionIdsToRerender = sections.map((
      /** @type {HTMLElement} */
      section
    ) => {
      let sectionId = section.closest('[id^="shopify-section-"]').id;
      // remove 'shopify-section-' from the id
      sectionId = sectionId.replace('shopify-section-', '');

      return sectionId;
    });

    const uniqueSections = [...new Set(sectionIdsToRerender)];

    // re-render all sections
    const url = new URL(window.location.href);
    url.searchParams.set('sections', uniqueSections.join(','));

    /** @type {Record<string, string | null>} */
    const response = cache[url.href] || await fetch(url.href).then((response) => response.json());

    cache[url.href] = response;


    // stop updating if the variant has changed
    if (variant !== new URLSearchParams(window.location.search).get('variant')) {
      return;
    }


    const parser = new DOMParser();

    // Check if View Transitions API is supported
    const supportsViewTransitions = document.startViewTransition !== undefined;

    // Function to handle the DOM update with transitions
    async function updateDOMWithTransition(section, newContent) {
      if (!supportsViewTransitions) {
        // Fallback for browsers that don't support view transitions
        section.innerHTML = newContent;
        return;
      }

      // Start a view transition
      const transition = document.startViewTransition(() => {
        section.innerHTML = newContent;
      });

      try {
        // Wait for the transition to complete
        await transition.finished;
      } catch (error) {
        console.error('View transition failed:', error);
      }
    }

    // Main section update logic
    sections.forEach(async (section) => {
      const key = section.getAttribute('data-rerender');
      const sectionId = section.closest('[id^="shopify-section-"]').id.replace('shopify-section-', '');
      const sectionData = response[sectionId];

      if (sectionData) {
        const doc = parser.parseFromString(sectionData, 'text/html');
        const newContent = doc.querySelector(`[data-rerender="${key}"]`)?.innerHTML || '';

        await updateDOMWithTransition(section, newContent);
      }
    });

  }

  // detetct current variant from URL on history change
  document.addEventListener('change', () => {
    let currentVariant = new URLSearchParams(window.location.search).get('variant');
    if (currentVariant !== variant) {
      variant = currentVariant;
      renderSections(variant);
    }
  });


})();